import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'Marcela G.',
  location: 'Córdoba',
  role: 'Terapeuta corporal'
}, {
  name: 'Jorge L.',
  location: 'Buenos Aires',
  role: 'Naturópata'
}, {
  name: 'Ana V.',
  location: 'Mendoza',
  role: 'Terapeuta floral'
}, {
  name: 'Valeria R.',
  location: 'Neuquén',
  role: 'Terapeuta bioenergética'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const interval = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 900);
    }, 30000);
    return () => {
      window.clearTimeout(show);
      window.clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-84" data-mp="20usl2qdue9qi">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 24,
      x: -12
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      type: 'spring',
      stiffness: 380,
      damping: 28
    }} aria-live="polite" className="fixed bottom-4 left-4 z-50 max-w-[calc(100%-2rem)] md:bottom-7 md:left-7 md:max-w-sm" data-id="element-85" data-mp="20tr7of9ctb5m">
          <div className="flex gap-3 rounded-2xl border border-brand-green/25 bg-brand-cream p-4 shadow-xl" data-id="element-86" data-mp="1hzc5yhvnr4e3">
            <div className="mt-0.5 rounded-full bg-brand-surfaceLight p-2" data-id="element-87" data-mp="1d4ptschr57sy">
              <CheckCircle2Icon className="h-5 w-5 text-brand-green" data-id="element-88" data-mp="187pnc0gzq31b" />
            </div>
            <div data-id="element-89" data-mp="139xw78o66ky6">
              <p className="text-xs text-brand-muted" data-id="element-90" data-mp="136a14532tqhc">
                Compra verificada · hace unos minutos
              </p>
              <p className="mt-1 text-sm text-brand-text" data-id="element-91" data-mp="u7opktw0vbq2">
                <strong data-id="element-92" data-mp="u86oxzdze627">{buyer.name}</strong> de {buyer.location}
              </p>
              <p className="text-xs text-brand-muted" data-id="element-93" data-mp="kj9ln3req15t">{buyer.role}</p>
              <p className="mt-1 text-sm font-bold text-brand-green" data-id="element-94" data-mp="om5wu9emauzq">
                adquirió Código Hepático™
              </p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}